import { render, staticRenderFns } from "./AcademyAD.vue?vue&type=template&id=4013b989&scoped=true"
import script from "./AcademyAD.vue?vue&type=script&lang=ts"
export * from "./AcademyAD.vue?vue&type=script&lang=ts"
import style0 from "./AcademyAD.vue?vue&type=style&index=0&id=4013b989&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4013b989",
  null
  
)

export default component.exports